import { ArrowLeft, ArrowRight } from "@phosphor-icons/react";
import { IconButton } from "@replicate/ui";
import { useCallback, useState } from "react";
import useDimensions from "react-cool-dimensions";
import { Document, Page, pdfjs } from "react-pdf";
import GlyphLoader from "../glyph-loader";

// todo(mattrothenberg)
// We ideally should be able to import this package from the modules
// in node_modules, but for some reason it doesn't work locally.
// This is a HACKY workaround to make it work for now.
pdfjs.GlobalWorkerOptions.workerSrc =
  "https://cdn.jsdelivr.net/npm/pdfjs-dist@4.8.69/build/pdf.worker.mjs";

export default function PDFRenderer({ url }: { url: string }) {
  const [numPages, setNumPages] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const { width, height, observe } = useDimensions();
  const activePage = currentPage + 1;

  const handlePrevPage = useCallback(() => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  }, [currentPage]);

  const handleNextPage = useCallback(() => {
    if (currentPage < numPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  }, [currentPage, numPages]);

  return (
    <div className="relative size-full flex flex-col overflow-hidden">
      <div className="size-full overflow-auto" ref={observe}>
        <Document
          file={url}
          loading={
            <div className="size-full flex items-center justify-center py-8 px-6 text-center">
              <div className="flex items-center gap-2">
                <div className="shrink-0">
                  <GlyphLoader />
                </div>
                <span className="text-r8-sm text-r8-gray-11">
                  Loading PDF preview
                </span>
              </div>
            </div>
          }
          error={
            <div className="size-full flex items-center justify-center py-8 px-6 text-center">
              <p className="text-r8-sm text-r8-red-10">
                Failed to render a preview of the PDF. <br /> Please download it
                to view.
              </p>
            </div>
          }
          onLoadSuccess={({ numPages }) => {
            setNumPages(numPages);
          }}
        >
          <Page
            width={width}
            height={height}
            className="w-full h-full"
            pageNumber={currentPage + 1}
          />
        </Document>
      </div>
      {numPages > 1 ? (
        <div className="absolute left-0 right-0 bottom-4 mx-auto w-24 flex items-center justify-between bg-white shadow-sm border border-r8-gray-6 z-10">
          <IconButton
            className="!text-black"
            size="sm"
            onClick={() => {
              handlePrevPage();
            }}
            variant="clear"
          >
            <ArrowLeft />
          </IconButton>
          <span className="text-r8-sm text-black py-1">
            {activePage} / {numPages}
          </span>
          <IconButton
            className="!text-black"
            size="sm"
            variant="clear"
            onClick={() => {
              handleNextPage();
            }}
          >
            <ArrowRight />
          </IconButton>
        </div>
      ) : null}
    </div>
  );
}
